import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import {
    DetailEmailLinkComponent,
    DetailMapItemLinkComponent,
    DetailPhoneLinkComponent,
    DetailViewModule,
} from '@ui/shared/ui-detail-view';
import { CultureMapItemModel } from '../../entities/culture-map-item.model';
import { CultureMapFacilityItemModel } from '../../entities/culture-map-facility-item.model';

@Component({
    selector: 'ui-culture-map-item-facility-detail',
    imports: [
        DetailMapItemLinkComponent,
        DetailViewModule,
        DetailPhoneLinkComponent,
        DetailEmailLinkComponent,
    ],
    templateUrl: './culture-map-item-facility-detail.component.html',
    styleUrl: './culture-map-item-facility-detail.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CultureMapItemFacilityDetailComponent {
    public readonly mapItemTriggeredById = output<CultureMapItemModel>();

    public facility = input.required<CultureMapFacilityItemModel>();

    public triggerMapItemById(linkedItem: CultureMapItemModel): void {
        this.mapItemTriggeredById.emit(linkedItem);
    }
}
